import {
  ColDef,
  GridOptions,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import React, { CSSProperties } from 'react';
import { DefaultTheme } from 'styled-components';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { IBid, IBidPanelRowDetails } from '../../services';

interface IGridProps {
  onGridEvent?: (event: GridReadyEvent) => void;
  onCellKeyDown?: (event: any) => void;
  onCellValueChanged?: (event: any) => void;
  hasExternalFilter?: boolean;
  theme?: DefaultTheme;
  gridOptions?: GridOptions;
  style?: CSSProperties;
  columns: ColDef[];
  defaultColDef?: ColDef;
  rowData: IBid[];
  auctionIdentification?: string;
  panelId: number;
  filterFunction?: (node: RowNode) => boolean;
}

const BidGrid: React.FC<IGridProps> = ({
  onGridEvent,
  onCellKeyDown,
  onCellValueChanged,
  hasExternalFilter = false,
  theme,
  gridOptions,
  style,
  columns,
  defaultColDef,
  rowData,
  auctionIdentification,
  panelId,
}) => {
  const [rowDataState, setRowDataState] = React.useState<IBidPanelRowDetails[]>(
    rowData?.[panelId - 1]?.bidPanelRowDetails || []
  );

  React.useEffect(() => {
    setRowDataState(rowData?.[panelId - 1]?.bidPanelRowDetails || []);
  }, [auctionIdentification, panelId, rowData]);

  return (
    <div
      className="ag-theme-alpine-dark"
      style={
        style || theme
          ? {
              height: '95%',
              width: '100%',
              fontSize: '0.75rem',
              fontFamily: '"Avenir Next", Tahoma, Helvetica, Arial, Roboto, sans-serif'
            }
          : undefined
      }
    >
      <AgGridReact
        key={`${auctionIdentification}-${panelId.toString()}`}
        rowData={rowDataState}
        columnDefs={columns}
        gridOptions={gridOptions}
        onGridReady={onGridEvent}
        onCellKeyDown={onCellKeyDown}
        onCellValueChanged={onCellValueChanged}
        stopEditingWhenCellsLoseFocus={true}
        isExternalFilterPresent={() => hasExternalFilter}
        defaultColDef={
          defaultColDef || {
            flex: 1,
            minWidth: 30,
          }
        }
      />
    </div>
  );
};

export default BidGrid;
